import React, { useEffect, useMemo, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import API, { UPLOADS_URL } from '../api/axios';
import SEO from '../components/SEO';
import Reveal from '../components/ui/Reveal';
import Lightbox from '../components/ui/Lightbox';

const CDN = 'https://www.sawssiddharthvihar.in/wp-content/uploads';

const achievementFiles = [
  'IMG_9253.PNG', 'IMG_9254.PNG', 'IMG_9256.PNG',
  'IMG_9263.PNG', 'IMG_9268.PNG', 'IMG_9269.PNG', 'IMG_9272.PNG',
];

const SLIDES = [
  { img: `${process.env.PUBLIC_URL}/images/sliders/1-siddharthvihar-slider.jpg`, alt: 'School Banner 1' },
  { img: `${process.env.PUBLIC_URL}/images/sliders/2-siddharthvihar-slider.jpg`, alt: 'School Banner 2' },
  { img: `${process.env.PUBLIC_URL}/images/sliders/3-siddharthvihar-slider.jpg`, alt: 'School Banner 3' },
  { img: `${process.env.PUBLIC_URL}/images/sliders/4-siddharthvihar-slider.jpg`, alt: 'School Banner 4' },
];

const TICKER_DEFAULT = { text: '✨ Admissions Open for Session 2027-28', url: '' };

import { API_URL } from '../api/axios';
const UPLOADS_BASE = API_URL;

const resolveImg = (src) => {
  if (!src) return src;
  if (src.startsWith('/frontend/')) return src.replace('/frontend/', '/');
  if (src.startsWith('http') || src.startsWith('/')) return src;
  return `${UPLOADS_BASE}/uploads/${src}`;
};

const FACILITY_DATA = [
  { img: `${process.env.PUBLIC_URL}/images/facilities/Junior-Classroom.jpg`, title: 'Junior Classroom' },
  { img: `${process.env.PUBLIC_URL}/images/facilities/Computer-Lab.jpg`, title: 'Computer Lab' },
  { img: `${process.env.PUBLIC_URL}/images/facilities/Science-Lab.jpg`, title: 'Science Lab' },
  { img: `${process.env.PUBLIC_URL}/images/facilities/Music-Room.jpg`, title: 'Music Room' },
  { img: `${process.env.PUBLIC_URL}/images/facilities/Library.jpg`, title: 'Library' },
  { img: `${process.env.PUBLIC_URL}/images/facilities/Infrastructure.jpg`, title: 'Infrastructure' },
];

const ACTIVITIES = [
  { img: `${process.env.PUBLIC_URL}/images/coactivities/Football.jpg`, name: 'Football' },
  { img: `${process.env.PUBLIC_URL}/images/coactivities/Taekwondo.jpg`, name: 'Taekwondo' },
  { img: `${process.env.PUBLIC_URL}/images/coactivities/Skating.jpg`, name: 'Skating' },
  { img: `${process.env.PUBLIC_URL}/images/coactivities/Swimming-Pool.jpg`, name: 'Swimming Pool' },
  { img: `${process.env.PUBLIC_URL}/images/coactivities/Chess.jpg`, name: 'Chess' },
  { img: `${process.env.PUBLIC_URL}/images/coactivities/Cricket.jpg`, name: 'Cricket' },
  { img: `${process.env.PUBLIC_URL}/images/coactivities/Badminton.jpg`, name: 'Badminton' },
  { img: `${process.env.PUBLIC_URL}/images/coactivities/Basketball.jpg`, name: 'Basketball' },
  { img: `${process.env.PUBLIC_URL}/images/coactivities/Art-Craft.jpg`, name: 'Art & Craft' },
];

const HIGHLIGHTS = [
  { img: `${process.env.PUBLIC_URL}/images/highlights/cer.jpg`, alt: 'Most Credible Group of Schools - Excellence in Education Award Singapore' },
  { img: `${process.env.PUBLIC_URL}/images/highlights/highlights-1.jpg`, alt: 'School Event 1' },
  { img: `${process.env.PUBLIC_URL}/images/highlights/highlights-2.jpg`, alt: 'School Event 2' },
  { img: `${process.env.PUBLIC_URL}/images/highlights/highlights-3.jpg`, alt: 'School Event 3' },
  { img: `${process.env.PUBLIC_URL}/images/highlights/highlights-4.jpg`, alt: 'School Event 4' },
  { img: `${process.env.PUBLIC_URL}/images/highlights/highlights-5.jpg`, alt: 'School Event 5' },
  { img: `${process.env.PUBLIC_URL}/images/highlights/highlights-6.jpg`, alt: 'School Event 6' },
  { img: `${process.env.PUBLIC_URL}/images/highlights/highlight-7.jpg`, alt: 'School Event 7' },
  { img: `${process.env.PUBLIC_URL}/images/highlights/highlight-8.jpg`, alt: 'School Event 8' },
  { img: `${process.env.PUBLIC_URL}/images/highlights/highlight-9.jpg`, alt: 'School Event 9' },
  { img: `${process.env.PUBLIC_URL}/images/highlights/DSC_7098.jpg`, alt: 'School Event 10' },
  { img: `${process.env.PUBLIC_URL}/images/highlights/DSC_7703.jpg`, alt: 'School Event 11' },
  { img: `${process.env.PUBLIC_URL}/images/highlights/DSC_7788.jpg`, alt: 'School Event 12' },
  { img: `${process.env.PUBLIC_URL}/images/highlights/DSC_8522.jpg`, alt: 'School Event 13' },
];

const WHY_US_DEFAULT = [
  { icon: 'fa-book-open', title: 'CBSE Curriculum' },
  { icon: 'fa-chalkboard-user', title: 'Smart Classrooms' },
  { icon: 'fa-trophy', title: 'Sports Excellence' },
  { icon: 'fa-shield-halved', title: 'Safe Campus' },
  { icon: 'fa-user-graduate', title: 'Experienced Faculty' },
  { icon: 'fa-seedling', title: 'Holistic Development' },
];

const PROCESS_DEFAULT = [
  { title: 'Enquiry', icon: 'fa-message', desc: 'Connect with our admission team to begin the journey.' },
  { title: 'Visit', icon: 'fa-school', desc: 'Tour our campus and experience the learning environment.' },
  { title: 'Assessment', icon: 'fa-clipboard-check', desc: 'Informal interaction or written test as per grade.' },
  { title: 'Admission', icon: 'fa-circle-check', desc: 'Complete the formalities and secure your seat.' },
];

const Home = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [notices, setNotices] = useState([]);
  const [events, setEvents] = useState([]);
  const [news, setNews] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [banners, setBanners] = useState([]);
  const [slides, setSlides] = useState([]);
  const [sectionData, setSectionData] = useState({});
  const [galleryAlbums, setGalleryAlbums] = useState([]);
  const [facilitiesState, setFacilitiesState] = useState(FACILITY_DATA);
  const [highlightsState, setHighlightsState] = useState(null);
  const [achievementsState, setAchievementsState] = useState([]);
  const [coCurricularState, setCoCurricularState] = useState(ACTIVITIES);
  const [testimonialsState, setTestimonialsState] = useState([]);
  const [partnersState, setPartnersState] = useState([]);
  const [awardsItemsState, setAwardsItemsState] = useState([
    { img: `${process.env.PUBLIC_URL}/images/awards/1.jpg.jpeg`, alt: 'Award 1' },
    { img: `${process.env.PUBLIC_URL}/images/awards/2.jpg.jpeg`, alt: 'Award 2' },
    { img: `${process.env.PUBLIC_URL}/images/awards/4.jpg.jpeg`, alt: 'Award 4' },
    { img: `${process.env.PUBLIC_URL}/images/awards/5.jpg.jpeg`, alt: 'Award 5' },
    { img: `${process.env.PUBLIC_URL}/images/awards/6.webp`, alt: 'Award 6' }
  ]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxItems, setLightboxItems] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const navigate = useNavigate();

  const ticker = { ...TICKER_DEFAULT, ...(sectionData.home_ticker || {}) };

  const openEnquiryPopup = (e) => {
    e.preventDefault();
    const btn = document.querySelector('.npfWidgetButton.npfWidget-19e823c49278038002c6e0e30ce39f61');
    if (btn) btn.click();
  };

  const highlightsRef = useRef(null);
  const achievementRef = useRef(null);
  const awardsRef = useRef(null);
  const autoSlideRef = useRef(null);
  const highlightsList = highlightsState?.length ? highlightsState : (sectionData.highlights?.items?.length ? sectionData.highlights.items : HIGHLIGHTS).map(i => ({ ...i, img: resolveImg(i.image || i.img) }));

  const aboutSec = sectionData.about && (sectionData.about.heading || sectionData.about.paragraphs) ? sectionData.about : null;
  const aboutKicker = aboutSec?.kicker || 'About St. Andrews';
  const aboutHeading = aboutSec?.heading || 'Welcome to the Best School in Siddharth Vihar';
  const aboutImage = aboutSec?.image ? resolveImg(aboutSec.image) : `${process.env.PUBLIC_URL}/images/aboutus.jpeg`;
  const aboutParagraphs = aboutSec?.paragraphs
    ? (typeof aboutSec.paragraphs === 'string'
        ? aboutSec.paragraphs.replace(/<\/p>/gi, '\n').replace(/<[^>]+>/g, '').split('\n').map(p => p.trim()).filter(Boolean)
        : [])
    : [
        "St. Andrews World School is dedicated to shaping tomorrow's leaders by providing an education that goes beyond academics. With six successful branches across India, our mission is to foster curiosity, ignite a passion for learning, and empower students to reach their fullest potential.",
        "Backed by a team of dedicated educators, state-of-the-art facilities, and a focus on diversity and inclusion, we provide a well-rounded education that integrates academics, sports, and arts alongside extracurricular activities.",
      ];
  const aboutBtnText = aboutSec?.btn_text || aboutSec?.button_text || 'Read More';
  const aboutBtnLink = aboutSec?.btn_link || aboutSec?.button_link || '/about-us';
  const rawVideos = aboutSec?.items || aboutSec?.videos || [];
  const aboutVideos = rawVideos
    .map(v => {
      const rawId = v?.video_id || v?.url || v?.video_url || '';
      const match = String(rawId).match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/);
      const video_id = match ? match[1] : String(rawId).trim();
      return { ...v, video_id };
    })
    .filter(v => v.video_id);
  const [aboutVideoIdx, setAboutVideoIdx] = useState(0);

  const whyUs = (sectionData.why_choose_us?.items?.length ? sectionData.why_choose_us.items : WHY_US_DEFAULT);
  const whyUsKicker = sectionData.why_choose_us?.kicker || 'Why Choose Us';
  const whyUsHeading = sectionData.why_choose_us?.heading || 'The St. Andrews Advantage';
  const whyUsDesc = sectionData.why_choose_us?.description || 'Every aspect of our school is designed to nurture confident, curious, and compassionate learners who are ready for the world.';

  const processItems = (sectionData.admission_process?.items?.length ? sectionData.admission_process.items : PROCESS_DEFAULT)
    .map((p, i) => ({ ...p, desc: p.desc || PROCESS_DEFAULT[i]?.desc || '' }));

  

  

  const achievementsList = achievementsState?.length ? achievementsState : (sectionData.achievements?.items?.length ? sectionData.achievements.items.map(a => ({ img: resolveImg(a.image || a.img), alt: a.alt || 'Student Achievement' })) : achievementFiles.map(f => ({ img: `${process.env.PUBLIC_URL}/images/Student-achievement/${f}`, alt: 'Student Achievement' })));

  const facSec = sectionData.facilities;
  const facKicker = facSec?.kicker || 'Facilities';
  const facHeading = facSec?.heading || 'Our Facilities';
  const facDesc = facSec?.description || 'St. Andrews World School, Siddharth Vihar is equipped with modern, thoughtfully designed facilities that support every aspect of a child\'s development.';
  const facilitiesList = facilitiesState?.length ? facilitiesState : (sectionData.facilities?.items?.length ? sectionData.facilities.items : FACILITY_DATA).map(i => ({ ...i, img: resolveImg(i.image || i.img) }));

  const actSec = sectionData.activities?.items?.length ? sectionData.activities : null;
  const actKicker = actSec?.kicker || 'Activities';
  const actHeading = actSec?.heading || 'Co-Curricular Activities';

  const testSec = sectionData.testimonials;
  const testKicker = testSec?.kicker || 'Testimonials';
  const testHeading = testSec?.heading || 'What Parents Say';

  const partSec = sectionData.partners;
  const partKicker = partSec?.kicker || 'Partners';
  const partHeading = partSec?.heading || 'Our Partners';

  const activitiesList = coCurricularState?.length ? coCurricularState : (sectionData.activities?.items?.length ? sectionData.activities.items : ACTIVITIES).map(i => ({ ...i, img: resolveImg(i.image || i.img) }));

  const scrollHighlights = (dir) => {
    if (highlightsRef.current) {
      const cardWidth = highlightsRef.current.querySelector('[class*="shrink-0"]')?.offsetWidth || 300;
      highlightsRef.current.scrollBy({ left: dir * (cardWidth + 16), behavior: 'smooth' });
    }
  };
  const scrollAchievement = (dir) => {
    if (achievementRef.current) {
      const cardWidth = achievementRef.current.querySelector('[class*="shrink-0"]')?.offsetWidth || 300;
      achievementRef.current.scrollBy({ left: dir * (cardWidth + 16), behavior: 'smooth' });
    }
  };
  const scrollAwards = (dir) => {
    if (awardsRef.current) {
      const cardWidth = awardsRef.current.querySelector('[class*="shrink-0"]')?.offsetWidth || 300;
      awardsRef.current.scrollBy({ left: dir * (cardWidth + 16), behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (highlightsList.length <= 1) return;
    autoSlideRef.current = setInterval(() => {
      if (highlightsRef.current) {
        const maxScroll = highlightsRef.current.scrollWidth - highlightsRef.current.clientWidth;
        const cardWidth = highlightsRef.current.querySelector('[class*="shrink-0"]')?.offsetWidth || 300;
        if (highlightsRef.current.scrollLeft >= maxScroll - 10) {
          highlightsRef.current.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          highlightsRef.current.scrollBy({ left: cardWidth + 16, behavior: 'smooth' });
        }
      }
    }, 3500);
    return () => clearInterval(autoSlideRef.current);
  }, [highlightsList.length]);

  useEffect(() => {
    const el = achievementRef.current;
    if (!el) return;
    const interval = setInterval(() => {
      const maxScroll = el.scrollWidth - el.clientWidth;
      const cardWidth = el.querySelector('[class*="shrink-0"]')?.offsetWidth || 300;
      if (el.scrollLeft >= maxScroll - 10) {
        el.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        el.scrollBy({ left: cardWidth + 16, behavior: 'smooth' });
      }
    }, 3500);
    return () => clearInterval(interval);
  }, [achievementsList.length]);

  useEffect(() => {
    const el = awardsRef.current;
    if (!el) return;
    const interval = setInterval(() => {
      const maxScroll = el.scrollWidth - el.clientWidth;
      const cardWidth = el.querySelector('[class*="shrink-0"]')?.offsetWidth || 300;
      if (el.scrollLeft >= maxScroll - 10) {
        el.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        el.scrollBy({ left: cardWidth + 16, behavior: 'smooth' });
      }
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (aboutVideos.length <= 1) return;
    const interval = setInterval(() => {
      setAboutVideoIdx(prev => (prev + 1) % aboutVideos.length);
    }, 12000);
    return () => clearInterval(interval);
  }, [aboutVideos.length]);

  useEffect(() => {
        const fetchData = async () => {
      try {
        const [noticeRes, eventsRes, newsRes, blogRes, bannerRes, sectionRes, facRes, highRes, achRes, coRes, awRes, testRes, partnerRes] = await Promise.all([
          API.get('/notices/latest').catch(()=>({data:{}})),
          API.get('/events/active').catch(()=>({data:{}})),
          API.get('/notices/news').catch(()=>({data:{}})),
          API.get('/blogs/latest').catch(()=>({data:{}})),
          API.get('/banners/active').catch(()=>({data:{}})),
          API.get('/home-sections').catch(()=>({data:{}})),
          API.get('/facilities/public').catch(()=>({data:{}})),
          API.get('/highlights/public').catch(()=>({data:{}})),
          API.get('/student-achievements/public').catch(()=>({data:{}})),
          API.get('/co-curricular-activities/public').catch(()=>({data:{}})),
          API.get('/awards/public').catch(()=>({data:{}})),
          API.get('/testimonials/public').catch(()=>({data:{}})),
          API.get('/knowledge-partners/public').catch(()=>({data:{}})),
        ]);
        if (noticeRes.data?.data?.length) setNotices(noticeRes.data.data);
        if (eventsRes.data?.data?.length) setEvents(eventsRes.data.data);
        if (newsRes.data?.data?.length) setNews(newsRes.data.data);
        if (blogRes.data?.data?.length) setBlogs(blogRes.data.data);
        if (bannerRes.data?.data?.length) {
          const mapped = bannerRes.data.data.map(b => ({
            img: resolveImg(b.image),
            alt: b.title || 'Banner',
            link: b.link,
            btn_text: b.btn_text,
          }));
          setSlides(mapped);
        } else {
          setSlides(SLIDES);
        }
        if (sectionRes.data?.data) setSectionData(sectionRes.data.data);
        
        if (facRes.data?.data?.length) {
          const sortedWithImages = [...facRes.data.data]
            .filter(f => f.image)
            .sort((a, b) => (a.sort_order - b.sort_order) || (a.id - b.id));
          const list = sortedWithImages.length ? sortedWithImages : facRes.data.data;
          setFacilitiesState(list.map(f => ({ img: resolveImg(f.image), title: f.title })));
        }
        if (highRes.data?.data?.length) {
          setHighlightsState(highRes.data.data.map(h => ({ img: resolveImg(h.image), alt: h.title })));
        }
        if (achRes.data?.data?.length) {
          setAchievementsState(achRes.data.data.map(a => ({ img: resolveImg(a.image), alt: a.title })));
        }
        if (coRes.data?.data?.length) {
          setCoCurricularState(coRes.data.data.map(c => ({ img: resolveImg(c.image), name: c.title })));
        }
        if (awRes.data?.data?.length) {
          setAwardsItemsState(awRes.data.data.map(a => ({ img: resolveImg(a.image), category: a.category, name: a.name, awarded_by: a.awarded_by, year: a.year })));
        }
        if (testRes?.data?.data?.length) {
          setTestimonialsState(testRes.data.data);
        }
        if (partnerRes?.data?.data?.length) {
          setPartnersState(partnerRes.data.data);
        }

        try {
          const galleryRes = await API.get('/galleries/public?limit=8');
          if (galleryRes.data?.data?.length) setGalleryAlbums(galleryRes.data.data);
        } catch (gErr) { console.error('Gallery fetch error:', gErr); }
      } catch (err) { console.error(err); }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (slides.length <= 1) return;
    const interval = setInterval(() => setActiveSlide(prev => (prev + 1) % slides.length), 4000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const prevSlide = () => setActiveSlide(prev => (prev - 1 + slides.length) % slides.length);
  const nextSlide = () => setActiveSlide(prev => (prev + 1) % slides.length);

  const openLightbox = (items, index = 0) => {
    const safe = Array.isArray(items) ? items.filter(Boolean) : [];
    if (safe.length === 0) return;
    setLightboxItems(safe);
    setLightboxIndex(Math.max(0, Math.min(index, safe.length - 1)));
    setLightboxOpen(true);
  };

  const noticesList = [...notices, ...news].filter(Boolean).slice(0, 4);
  const eventsList = events.slice(0, 4);
  const fmtDate = (str) => {
    if (!str) return '';
    const d = new Date(str);
    return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  return (
    <>
      <SEO
        title="Home"
        description="St. Andrews World School, Siddharth Vihar - premium CBSE education with modern learning, holistic development, and world-class facilities. Admissions open for 2027-28."
        keywords="CBSE school in Siddharth Vihar, best school in Siddharth Vihar, admissions 2027-28, St. Andrews World School, CBSE curriculum, smart classrooms, sports, activities"
        schema={[
          {
            '@context': 'https://schema.org',
            '@type': 'School',
            name: 'St. Andrews World School',
            url: (process.env.REACT_APP_SITE_URL || 'https://sawssiddharthvihar.in'),
            address: { '@type': 'PostalAddress', addressLocality: 'Siddharth Vihar', addressRegion: 'Haryana', addressCountry: 'IN' },
          },
        ]}
      />

      {/* ============ H1 (visually hidden, accessible) ============ */}
      <h1 className="sr-only">St. Andrews World School Siddharth Vihar — Best CBSE School in Ghaziabad</h1>

      {/* ============ HERO ============ */}
      <section className="relative bg-midnight overflow-hidden">
        <div className="relative h-[280px] sm:h-[350px] md:h-[420px] lg:h-[540px] xl:h-[600px]">
          {slides.map((slide, i) => (
            <div
              key={i}
              className={`absolute inset-0 transition-opacity duration-1000 ${i === activeSlide ? 'opacity-100 z-0' : 'opacity-0 z-0'}`}
              aria-hidden={i !== activeSlide}
            >
              <img src={slide.img} alt={slide.alt} className="w-full h-full object-fill md:object-cover" loading={i === activeSlide ? 'eager' : 'lazy'} />
            </div>
          ))}

          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-[#0d1b3e]/60 via-transparent to-transparent z-[1]"></div>

          {/* Slide dots */}
          {slides.length > 1 && (
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-[3] flex gap-2.5">
              {slides.map((_, i) => (
                <button
                  key={i}
                  aria-label={`Go to slide ${i + 1}`}
                  className={`rounded-full border-none cursor-pointer transition-all duration-500 ${
                    i === activeSlide ? 'bg-[#D4A73E] w-8 h-2.5' : 'bg-white/40 w-2.5 h-2.5 hover:bg-white/70'
                  }`}
                  onClick={() => setActiveSlide(i)}
                />
              ))}
            </div>
          )}

          {/* Arrows */}
          {slides.length > 1 && (
            <>
              <button onClick={prevSlide} aria-label="Previous slide" className="btn-nav bg-white/10 backdrop-blur border border-white/20 text-white hover:bg-white/25 absolute left-4 top-1/2 -translate-y-1/2 z-[3]"><i className="fas fa-chevron-left text-sm"></i></button>
              <button onClick={nextSlide} aria-label="Next slide" className="btn-nav bg-white/10 backdrop-blur border border-white/20 text-white hover:bg-white/25 absolute right-4 top-1/2 -translate-y-1/2 z-[3]"><i className="fas fa-chevron-right text-sm"></i></button>
            </>
          )}
        </div>
      </section>

      {/* ============ ADMISSIONS TICKER ============ */}
      <section className="bg-[#1B3160] border-b border-white/10 py-3.5 relative overflow-hidden">
        <div className="container">
          <a
            href={ticker.url || '#'}
            onClick={ticker.url ? undefined : openEnquiryPopup}
            className="text-white/90 hover:text-white text-[14px] md:text-[16px] font-medium no-underline tracking-wide transition-colors cursor-pointer flex items-center justify-center gap-2 text-center"
          >
            <span>{ticker.text}</span>
          </a>
        </div>
      </section>

      {/* ============ ABOUT ============ */}
      <Reveal>
        <section className="py-14 md:py-20 bg-white relative overflow-hidden">
          <div className="absolute top-24 -right-24 w-96 h-96 rounded-full bg-[#1B3160]/5 blur-3xl"></div>
          <div className="container relative overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center">
              <div className="relative max-lg:order-2">
                <div className="absolute -inset-1 bg-gradient-to-br from-[#D4A73E]/30 to-[#1B3160]/20 rounded-3xl blur-lg opacity-60 pointer-events-none"></div>
                {aboutVideos.length ? (
                  <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                    <div className="relative" style={{ paddingBottom: '56.25%', height: 0 }}>
                      {aboutVideos.map((v, i) => (
                        <iframe
                          key={v.video_id}
                          src={`https://www.youtube.com/embed/${v.video_id}${i === aboutVideoIdx ? '?autoplay=1&mute=1' : ''}`}
                          title={v.title || 'School Video'}
                          className="absolute inset-0 w-full h-full transition-opacity duration-500"
                          style={{ border: 'none', opacity: i === aboutVideoIdx ? 1 : 0, zIndex: i === aboutVideoIdx ? 1 : 0 }}
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                          loading="lazy"
                        />
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                    <img src={aboutImage} alt="About St. Andrews World School" className="w-full h-auto object-cover" loading="lazy" />
                  </div>
                )}
              </div>
              <div className="max-lg:order-1">
                <div className="kicker">{aboutKicker}</div>
                <h2 className="text-[28px] md:text-[38px] font-bold text-primary mt-2 mb-4 leading-tight">{aboutHeading}</h2>
                <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mb-7"></div>
                {aboutParagraphs.map((p, i) => (
                  <p key={i} className="text-body text-[16px] md:text-[17px] leading-relaxed mb-5" style={{ WebkitHyphens: 'none', msHyphens: 'none', hyphens: 'none', textAlign: 'left' }}>{p}</p>
                ))}
                <Link to={aboutBtnLink} className="btn-navy">{aboutBtnText} <i className="fas fa-arrow-right text-[11px]"></i></Link>
              </div>
            </div>
          </div>
        </section>
      </Reveal>

      {/* ============ HIGHLIGHTS ============ */}
      <Reveal>
        <section className="py-14 md:py-20 bg-[#1B3260] relative overflow-hidden">
          <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)', backgroundSize: '24px 24px' }} />
          <div className="container relative overflow-hidden">
            <div className="text-center mb-12">
              <div className="kicker text-[#F3D27E]">{sectionData.highlights?.kicker || 'Highlights'}</div>
              <h2 className="text-[28px] md:text-[38px] font-bold text-white mt-2">{sectionData.highlights?.heading || 'Achievements & Moments'}</h2>
              <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mx-auto mt-4"></div>
            </div>
            <div className="relative">
              <div ref={highlightsRef} className="flex gap-4 md:gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-2 hide-scrollbar justify-start">
                {highlightsList.map((item, idx) => (
                  <button
                    key={item.img}
                    type="button"
                    className="snap-start shrink-0 w-[75vw] sm:w-[300px] rounded-xl overflow-hidden border border-white/10 bg-white shadow-sm hover:shadow-2xl transition-all group"
                    onClick={() => openLightbox(highlightsList, idx)}
                  >
                    <div className="relative h-[320px] md:h-[380px] overflow-hidden">
                      <img
                        src={item.img}
                        alt={item.alt}
                        className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors"></div>
                    </div>
                  </button>
                ))}
              </div>
              {highlightsList.length > 1 && (
                <>
                  <button onClick={() => scrollHighlights(-1)} aria-label="Previous" className="btn-nav absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1.5 sm:-translate-x-3 bg-white text-[#1B3260] shadow-lg hover:bg-gray-50 z-10"><i className="fas fa-chevron-left text-sm"></i></button>
                  <button onClick={() => scrollHighlights(1)} aria-label="Next" className="btn-nav absolute right-0 top-1/2 -translate-y-1/2 translate-x-1.5 sm:translate-x-3 bg-white text-[#1B3260] shadow-lg hover:bg-gray-50 z-10"><i className="fas fa-chevron-right text-sm"></i></button>
                </>
              )}
            </div>
          </div>
        </section>
      </Reveal>

      {/* ============ STUDENT ACHIEVEMENTS ============ */}
      <Reveal>
        <section className="py-14 md:py-20 bg-white">
          <div className="container">
            <div className="text-center mb-12">
              <div className="kicker">Student Achievement</div>
              <h2 className="text-[26px] md:text-[32px] font-bold text-primary mt-2">Our Achievers</h2>
              <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mx-auto mt-4"></div>
            </div>
            <div className="relative">
              <div ref={achievementRef} className="flex gap-4 md:gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-2 hide-scrollbar justify-start">
                {achievementsList.map((file, idx) => (
                  <Reveal key={file.img || file.image} delayMs={idx * 50} className="shrink-0 snap-start w-[75vw] sm:w-[300px]">
                    <button
                      type="button"
                      onClick={() => openLightbox(achievements, idx)}
                      className="group w-full rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                    >
                      <div className="relative overflow-hidden" style={{ aspectRatio: '4 / 5' }}>
                        <img
                          src={file.img}
                          alt={file.alt || 'Student Achievement'}
                          className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105"
                          loading="lazy"
                        />
                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                          <div className="w-12 h-12 rounded-full bg-white/90 text-primary flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-4 group-hover:translate-y-0">
                            <i className="fas fa-expand text-sm" />
                          </div>
                        </div>
                      </div>
                    </button>
                  </Reveal>
                ))}
              </div>
              {achievementsList.length > 1 && (
                <>
                  <button onClick={() => scrollAchievement(-1)} aria-label="Previous" className="btn-nav absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1.5 sm:-translate-x-3 bg-white shadow-lg border border-gray-100 text-[#1B3160] hover:bg-gray-50 z-10"><i className="fas fa-chevron-left text-sm"></i></button>
                  <button onClick={() => scrollAchievement(1)} aria-label="Next" className="btn-nav absolute right-0 top-1/2 -translate-y-1/2 translate-x-1.5 sm:translate-x-3 bg-white shadow-lg border border-gray-100 text-[#1B3160] hover:bg-gray-50 z-10"><i className="fas fa-chevron-right text-sm"></i></button>
                </>
              )}
            </div>
          </div>
        </section>
      </Reveal>

      {/* ============ AWARDS ============ */}
      <Reveal>
        <section className="py-14 md:py-20 bg-[#1B3260] relative overflow-hidden">
          <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)', backgroundSize: '24px 24px' }} />
          <div className="container relative">
            <div className="text-center mb-12">
              <div className="kicker text-[#F3D27E]">Awards</div>
              <h2 className="text-[26px] md:text-[32px] font-bold text-white mt-2">Our Awards & Recognition</h2>
              <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mx-auto mt-4"></div>
            </div>
            <div className="relative">
              <div ref={awardsRef} className="flex gap-4 md:gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-2 hide-scrollbar justify-start">
                {awardsItemsState.map((award, i) => (
                  <div key={i} className="group snap-start shrink-0 w-[80vw] sm:w-[calc(50%-0.5rem)] md:w-[calc(33.333%-1rem)] lg:w-[calc(25%-1.125rem)] overflow-hidden transition-all duration-500 flex justify-center items-center">
                    <div className="relative w-full flex justify-center items-center">
                      <img
                        src={award.img}
                        alt={award.name || award.alt || 'Award'}
                        className="w-auto h-auto max-w-full max-h-[400px] object-contain group-hover:scale-105 transition-transform duration-500 shadow-md rounded-xl"
                        loading="lazy"
                      />
                    </div>
                  </div>
                ))}}
              </div>
              <button onClick={() => scrollAwards(-1)} aria-label="Previous" className="btn-nav absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1.5 sm:-translate-x-3 bg-white text-[#1B3260] shadow-lg hover:bg-gray-50 z-10"><i className="fas fa-chevron-left text-sm"></i></button>
              <button onClick={() => scrollAwards(1)} aria-label="Next" className="btn-nav absolute right-0 top-1/2 -translate-y-1/2 translate-x-1.5 sm:translate-x-3 bg-white text-[#1B3260] shadow-lg hover:bg-gray-50 z-10"><i className="fas fa-chevron-right text-sm"></i></button>
            </div>
          </div>
        </section>
      </Reveal>

      {/* ============ FACILITIES ============ */}
      <Reveal>
        <section className="py-14 md:py-20 bg-white">
          <div className="container">
            <div className="text-center mb-12">
              <div className="kicker">{facKicker}</div>
              <h2 className="text-[26px] md:text-[32px] font-bold text-primary mt-2">{facHeading}</h2>
              <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mx-auto mt-4"></div>
              <div className="text-body text-[15px] md:text-base max-w-3xl mx-auto mt-4 prose" dangerouslySetInnerHTML={{ __html: facDesc }} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {facilitiesList.slice(0, 6).map((f, i) => (
                <Reveal key={f.title} delayMs={i * 70}>
                  <button type="button" className="relative group w-full text-left" onClick={() => openLightbox(facilitiesList.map(x => ({ img: x.img, alt: x.title })), i)}>
                    <div className="relative overflow-hidden rounded-2xl shadow-md border border-gray-100">
                      <div className="h-[280px] overflow-hidden">
                        <img src={f.img} alt={f.title} className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110" loading="lazy" />
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent"></div>
                      <div className="absolute bottom-0 left-0 right-0 p-5 flex items-center justify-between">
                        <h3 className="text-white text-lg font-semibold">{f.title}</h3>
                        <div className="w-9 h-9 rounded-full bg-[#D4A73E] text-[#0d1b3e] flex items-center justify-center opacity-0 group-hover:opacity-100 translate-x-3 group-hover:translate-x-0 transition-all duration-300"><i className="fas fa-arrow-right text-xs"></i></div>
                      </div>
                    </div>
                  </button>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      </Reveal>

      {/* ============ ACTIVITIES ============ */}
      <Reveal>
        <section className="py-14 md:py-20 bg-[#1B3160] relative overflow-hidden">
          <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)', backgroundSize: '24px 24px' }} />
          <div className="container relative">
            <div className="text-center mb-12">
              <div className="kicker text-[#F3D27E]">{actKicker}</div>
              <h2 className="text-[26px] md:text-[32px] font-bold text-white mt-2">{actHeading}</h2>
              <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mx-auto mt-4"></div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {activitiesList.slice(0, 6).map((activity, i) => (
                <Reveal key={activity.name} delayMs={i * 70}>
                  <button type="button" className="relative group w-full text-left" onClick={() => openLightbox(activitiesList.map(x => ({ img: x.img, alt: x.name })), i)}>
                    <div className="relative overflow-hidden rounded-2xl shadow-md border border-white/10">
                      <div className="h-[280px] overflow-hidden">
                        <img src={activity.img} alt={activity.name} className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110" loading="lazy" />
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent"></div>
                      <div className="absolute bottom-0 left-0 right-0 p-5 flex items-center justify-between gap-3">
                        <h3 className="text-white text-lg font-semibold">{activity.name}</h3>
                        <div className="w-9 h-9 rounded-full bg-[#D4A73E] text-[#0d1b3e] flex items-center justify-center opacity-0 group-hover:opacity-100 translate-x-3 group-hover:translate-x-0 transition-all duration-300 shrink-0"><i className="fas fa-arrow-right text-xs"></i></div>
                      </div>
                    </div>
                  </button>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      </Reveal>

      {/* ============ TESTIMONIALS ============ */}
      {testimonialsState?.length > 0 && (
        <Reveal>
          <section className="py-14 md:py-20 bg-gray-50 relative overflow-hidden">
            <div className="container relative z-10">
              <div className="text-center mb-12">
                <div className="kicker">{testKicker}</div>
                <h2 className="text-[26px] md:text-[32px] font-bold text-primary mt-2">{testHeading}</h2>
                <div className="w-14 h-[3px] bg-[#D4A73E] rounded-full mx-auto mt-4"></div>
              </div>

              <div className="flex gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-6 hide-scrollbar justify-start">
                {testimonialsState.map((t, i) => (
                  <div key={i} className="snap-start shrink-0 w-[85vw] md:w-[450px] bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 flex flex-col relative">
                    <div className="text-[#D4A73E] opacity-20 absolute top-6 right-8">
                      <i className="fas fa-quote-right text-6xl"></i>
                    </div>
                    
                    {t.type === 'video' && t.video_url ? (
                      <div className="mb-6 rounded-xl overflow-hidden aspect-video relative bg-gray-100 z-10 shadow-sm border border-gray-100">
                        <iframe 
                          src={t.video_url.replace("watch?v=", "embed/").replace("youtu.be/", "youtube.com/embed/")} 
                          title={t.name} 
                          className="absolute inset-0 w-full h-full border-0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                          allowFullScreen
                        ></iframe>
                      </div>
                    ) : (
                      <p className="text-gray-600 italic mb-8 flex-grow leading-relaxed z-10 relative mt-4">
                        "{t.quote}"
                      </p>
                    )}
                    
                    <div className="flex items-center gap-4 mt-auto z-10">
                      <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center shrink-0 shadow-sm">
                        <span className="font-bold text-lg">{t.name.charAt(0)}</span>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900">{t.name}</h4>
                        {t.designation && <p className="text-sm text-gray-500">{t.designation}</p>}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </Reveal>
      )}





      {/* ============ OUR PARTNERS ============ */}
      {partnersState?.length > 0 && (
        <Reveal>
          <section className="py-12 md:py-16 bg-[#faf9f6]">
            <div className="container relative">
              <div className="text-center mb-10">
                <h2 className="text-[28px] md:text-[34px] font-bold text-[#1B3160]" style={{ fontFamily: '"Playfair Display", serif' }}>{partHeading}</h2>
                <div className="flex items-center justify-center gap-3 mt-3">
                  <div className="w-16 h-[1px] bg-gray-400"></div>
                  <i className="fas fa-star text-[#D4A73E] text-[10px]"></i>
                  <div className="w-16 h-[1px] bg-gray-400"></div>
                </div>
              </div>

              <div className="absolute top-0 right-4 hidden md:flex items-center gap-1.5 mt-2">
                <button onClick={() => {
                  const s = document.getElementById('partners-slider');
                  if(s) s.scrollBy({ left: -250, behavior: 'smooth' });
                }} className="w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-[#1B3160] text-gray-500 hover:text-white transition-colors"><i className="fas fa-chevron-left text-xs"></i></button>
                <button onClick={() => {
                  const s = document.getElementById('partners-slider');
                  if(s) s.scrollBy({ left: 250, behavior: 'smooth' });
                }} className="w-8 h-8 flex items-center justify-center bg-gray-200 hover:bg-[#1B3160] text-gray-500 hover:text-white transition-colors"><i className="fas fa-chevron-right text-xs"></i></button>
              </div>

              <div id="partners-slider" className="flex gap-4 md:gap-5 overflow-x-auto scroll-smooth snap-x snap-mandatory hide-scrollbar pb-6 justify-start items-center">
                {partnersState.map((partner, i) => (
                  <div key={i} className="snap-start shrink-0 w-[200px] h-[200px] bg-white rounded-[20px] shadow-[0_2px_15px_rgba(0,0,0,0.04)] border border-gray-300 flex items-center justify-center p-6">
                    <img src={resolveImg(partner.image)} alt={partner.title} className="max-w-full max-h-full object-contain transition-all duration-300 hover:scale-105" loading="lazy" />
                  </div>
                ))}
              </div>
              
              <div className="flex justify-center items-center gap-1.5 mt-2">
                <div className="w-5 h-1.5 rounded-full bg-gray-600"></div>
                <div className="w-1.5 h-1.5 rounded-full bg-gray-300"></div>
              </div>
            </div>
          </section>
        </Reveal>
      )}

      <Lightbox
        open={lightboxOpen}
        items={lightboxItems}
        initialIndex={lightboxIndex}
        onClose={() => setLightboxOpen(false)}
      />
    </>
  );
};

export default Home;